import React from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./RestaurantList.scss"
import settings from "../../constants/restaurantSlider"
import { Card, Rate } from "antd"
import {
  suggestRestaurant,
  getRestaurantMenu,
  setLoadingMenus,
} from "../../redux/actionCreators/planDinnner"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import _ from "../../utils/lodashUtils"
import orderBy from "lodash/orderBy"
import MenuPopup from "../MenuPopup/MenuPopup"
import {
  RESTAURANT_ACCEPTED_TITLE,
  NO_RATING,
  ETA,
  SUGGEST_BUTTON,
  CLOSED,
  EXPLORE_MENU,
  RESTAURANT_ACCEPTED_CONTENT,
  TAKE_ME_TO_MENU,
  PROMOTION,
  RESTAURANT_UNAVAILABLE,
} from "../../constants/messages"
import { isClosedRestaurant } from "../../utils/helpers"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { SUGGESTION_STATES } from "../../constants/commons"
import { usePrevious, useIsMobile } from "common-custom-hooks"
import { emitter } from "../../utils/emitter"
import { CUSTOM_EVENTS } from "../../constants/commons"
import { TextTag, Button, CustomModal as Modal } from "../../atoms"
import SuggestArrow from "../../assets/images/SuggestArrow.svg"
import Tag from "../Tag/Tag"
import { RestaurantSlider } from "./RestaurantSlider"
import { ActivityIndicator } from "../ActivityIndicator"

const { Meta } = Card

const RestaurantList = props => {
  const {
    user,
    partner,
    getRestaurantMenu,
    isPartnerAway,
    history,
    isDateWait,
    setLoadingMenus,
    loadingMenus,
    showPartnerBackToPlanningModal,
  } = props
  const [modalVisible, setModalVisble] = React.useState(false)
  const [promotionModal, setPromotionModal] = React.useState(false)
  const [selectedRestaurant, setSelectedRestaurant] = React.useState(false)
  const [isRestaurantAccepted, setIsRestaurantAccepted] = React.useState(false)
  const [menuForRestaurant, setMenuForRestaurant] = React.useState("")
  const [showRestAurantArrowButton, setRestaurantArrowButton] = React.useState(
    false
  )
  const isDesktop = useIsMobile(1600)
  const isMobile = useIsMobile(1024)
  const isSmallMobile = useIsMobile(768)

  const { dateState, userState, partnerState } = React.useContext(
    FirebaseContext
  )
  const allRestaurants = props.restaurantsList
    ? props.restaurantsList
    : props.restaurants
  const unsortedRestaurants = Object.values(allRestaurants)
  const partnerAddress = _.get(
    partnerState,
    "userDetails.address.user_address",
    false
  )

  const sortDeliveryCloseRestaurants = orderBy(
    unsortedRestaurants,
    "order_time.delivery",
    ["desc"]
  )
  const sortPromotionRestaurants = sortDeliveryCloseRestaurants.sort(
    (rest1, rest2) => {
      if (rest1.specials.length === 0) {
        return 1
      } else if (rest2.specials.length === 0) {
        return -1
      }
      return 0
    }
  )
  const sortAllOpenRestaurantsFirst = orderBy(
    sortPromotionRestaurants,
    "order_time.open",
    ["desc"]
  )

  let pendingRestaurantSuggestion = {}
  const suggestedRestaurant = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
    {}
  )
  if (
    suggestedRestaurant[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.PENDING
  ) {
    pendingRestaurantSuggestion = suggestedRestaurant
  }

  const previousSuggestedRestaurant = usePrevious(suggestedRestaurant)
  const restaurantsList = Object.values(sortAllOpenRestaurantsFirst)

  const resetRestaurant = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT}.${FIREBASE_STATE_KEYS.RESET_RESTAURANT}`,
    false
  )
  const showMenuModal = restaurant => {
    const transformedRestaurantObj = {
      id: restaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      name: restaurant[FIREBASE_STATE_KEYS.RESTAURANT_NAME],
    }
    exploreMenu(transformedRestaurantObj)()
  }
  const hideMenuModal = () => setModalVisble(false)

  React.useEffect(() => {
    const showMenuListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_RESTAURANT_MENU,
      showMenuModal
    )
    const hideMenuListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_RESTAURANT_MENU,
      hideMenuModal
    )
    return () => {
      showMenuListener.remove()
      hideMenuListener.remove()
    }
  }, [])

  React.useEffect(() => {
    if (
      !_.isEqual(previousSuggestedRestaurant, suggestedRestaurant) &&
      suggestedRestaurant[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
        SUGGESTION_STATES.ACCEPTED
    ) {
      setIsRestaurantAccepted(true)
    }
  }, [userState, suggestedRestaurant, partnerAddress])

  // Arrow Button display usecase
  React.useEffect(() => {
    const length = restaurantsList.length
    if (length <= 3) {
      settings.infinite = false
    }
    if (length <= 3 && isDesktop) {
      setRestaurantArrowButton(false)
    }
    if (length <= 2 && isMobile) {
      setRestaurantArrowButton(false)
    }
    if (length === 1 && isSmallMobile) {
      setRestaurantArrowButton(false)
    }

    if (length > 3) {
      setRestaurantArrowButton(true)
    }
    if (length > 2 && isMobile) {
      setRestaurantArrowButton(true)
    }
    if (length > 1 && isSmallMobile) {
      setRestaurantArrowButton(true)
    }
  }, [restaurantsList, isMobile, isSmallMobile])

  const stars = current => {
    const { ratings } = current
    if (ratings && ratings["star_rating"] > 0) {
      return (
        <Rate
          allowHalf
          disabled
          defaultValue={current.ratings["star_rating"]}
        ></Rate>
      )
    } else {
      return <TextTag style={{ color: "grey" }}>{NO_RATING}</TextTag>
    }
  }

  const renderCuisines = restaurant => {
    const cuisines = _.get(restaurant, "cuisines", [])
    let cuisineString = ""

    cuisines.forEach((cuisine, index) => {
      if (index === cuisines.length - 1) {
        cuisineString = `${cuisineString}${cuisine}`
      } else {
        cuisineString = `${cuisineString}${cuisine}, `
      }
    })

    if (cuisines) {
      return cuisineString
    }
    return null
  }

  const renderDollars = restaurant => {
    return [...Array(restaurant.price_rating)].map((e, i) => (
      <TextTag textType="sectionTextPrimary" key={i}>
        $
      </TextTag>
    ))
  }

  const onSuggestRestaurant = current => async () => {
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT]: {
          [FIREBASE_STATE_KEYS.RESTAURANT_NAME]: current.name,
          [FIREBASE_STATE_KEYS.RESTAURANT_ID]: `${current.id}`,
          [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: SUGGESTION_STATES.PENDING,
          [FIREBASE_STATE_KEYS.DELIVERY_MINIMUM]: `${current.range.calculated.delivery_minimum.lowest}`,
          [FIREBASE_STATE_KEYS.RESTAURANT_ADDRESS]:
            current.location.street +
            "," +
            current.location.state +
            "," +
            current.location.zip,
        },
      },
      `${FirebaseService.getDefaultPath()}${user.uuid}`
    )
  }

  const isSuggestedRestaurant = restaurantId => {
    return (
      pendingRestaurantSuggestion &&
      _.get(
        pendingRestaurantSuggestion,
        FIREBASE_STATE_KEYS.RESTAURANT_ID,
        ""
      ) === `${restaurantId}`
    )
  }

  const renderCardCover = current => {
    return (
      <div className="cover-body">
        <div>
          <img
            id="restaurantList"
            alt="restaurantList"
            src={current.logo_url}
          />
        </div>
        {!isDateWait && (
          <div>
            <div>
              {!props.isSuggestRequired ? null : (
                <Button
                  className="card-select-btn"
                  size={"small"}
                  onClick={onSuggestRestaurant(current)}
                  disabled={
                    !partnerAddress ||
                    isPartnerAway ||
                    isClosedRestaurant(current)
                  }
                >
                  {isClosedRestaurant(current) ? (
                    CLOSED
                  ) : (
                    <div className="suggest-btn">
                      {SUGGEST_BUTTON}
                      <img src={SuggestArrow} alt="suggest" />
                    </div>
                  )}
                </Button>
              )}
            </div>

            <div>
              <Button
                className="card-select-btn-menu"
                size={"small"}
                onClick={exploreMenu(current)}
                disabled={current.id == loadingMenus}
              >
                {current.id == loadingMenus && <ActivityIndicator />}
                {EXPLORE_MENU}
              </Button>
            </div>
          </div>
        )}
      </div>
    )
  }
  const exploreMenu = restaurant => async () => {
    setLoadingMenus(restaurant.id)
    try {
      await getRestaurantMenu(restaurant.id)
      setMenuForRestaurant(restaurant.name)
      setModalVisble(true)
      setLoadingMenus(null)
    } catch (error) {
      console.log(error)
    }
  }

  const handleCancel = () => {
    setModalVisble(false)
    setLoadingMenus(null)
  }

  // Restaurants suggested by partner
  let partnersuggestedRestaurant = {}
  const restaurantSuggested = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT}`
  )
  if (
    restaurantSuggested &&
    restaurantSuggested[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
      SUGGESTION_STATES.PENDING
  ) {
    partnersuggestedRestaurant = restaurantSuggested
  }

  const isPartnerSuggestedRestaurant = restaurantId => {
    return (
      partnersuggestedRestaurant &&
      _.get(
        partnersuggestedRestaurant,
        FIREBASE_STATE_KEYS.RESTAURANT_ID,
        ""
      ) === `${restaurantId}`
    )
  }

  return (
    <div id="RestaurantList">
      <div className="container">
        {restaurantsList.length === 0 ? (
          <div />
        ) : (
          <RestaurantSlider
            showArrow={showRestAurantArrowButton}
            length={restaurantsList.length}
            isDateWait={isDateWait}
          >
            {restaurantsList.map(current => (
              <section key={current.id} className="restaurant-card-container">
                {isDateWait && isClosedRestaurant(current) && (
                  <div className="overlay">
                    <div className="overlay-text">
                      <TextTag>{RESTAURANT_UNAVAILABLE}</TextTag>
                    </div>
                  </div>
                )}
                <Card
                  hoverable
                  bordered
                  className={`restaurant-card${
                    isSuggestedRestaurant(current.id) ? "-selected" : ""
                  }  ${
                    isPartnerSuggestedRestaurant(current.id)
                      ? "partner-suggested-restaurant"
                      : ""
                  }`}
                  cover={renderCardCover(current)}
                >
                  <div className="name-price">
                    <Meta title={current.name} />
                    <span className="price-rating">
                      {renderDollars(current)}
                    </span>
                  </div>
                  {!isDateWait && !!current.specials.length && (
                    <div className="promotion">
                      <Tag
                        disabled={isClosedRestaurant(current)}
                        onClick={() => {
                          setSelectedRestaurant(current)
                          setPromotionModal(true)
                        }}
                        text={PROMOTION}
                      />
                    </div>
                  )}
                  <div className="cuisine-container">
                    <TextTag textType="smallTextPrimary">
                      {renderCuisines(current)}
                    </TextTag>
                  </div>
                  <div>{stars(current)}</div>
                  <div className="eta-pricing">
                    <TextTag textType="default" className="eta-pricing">
                      {ETA(current.availability["delivery_estimate"])}
                    </TextTag>
                  </div>
                </Card>
              </section>
            ))}
          </RestaurantSlider>
        )}
      </div>
      <Modal
        title={menuForRestaurant}
        visible={modalVisible && !showPartnerBackToPlanningModal}
        keyboard={false}
        onCancel={handleCancel}
        footer={[]}
      >
        {modalVisible && <MenuPopup />}
      </Modal>
      <Modal
        title={RESTAURANT_ACCEPTED_TITLE(
          _.get(partnerState, "userDetails.display_name")
        )}
        visible={isRestaurantAccepted && !resetRestaurant}
        keyboard={false}
        footer={[
          <Button
            className="save-btn"
            type="primary"
            key={TAKE_ME_TO_MENU}
            onClick={async () => {
              await FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${partner.uuid}/${
                  FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT
                }`
              )
              await FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${user.uuid}/${
                  FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT
                }`
              )
              await FirebaseService.setActiveRoute("/confirm-date")
              history.push("/confirm-date")
            }}
          >
            {TAKE_ME_TO_MENU}
          </Button>,
        ]}
      >
        <TextTag>{RESTAURANT_ACCEPTED_CONTENT}</TextTag>
      </Modal>
      <Modal
        visible={promotionModal && !showPartnerBackToPlanningModal}
        title={PROMOTION}
        keyboard={false}
        onCancel={() => {
          setPromotionModal(false)
        }}
        footer={[
          _.get(selectedRestaurant.specials, "promotions.featured_message", ""),
        ]}
      >
        {selectedRestaurant &&
          selectedRestaurant.specials.map(special => (
            <div className="special">{special.name}</div>
          ))}
      </Modal>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    partner: _.get(state, "auth.partner", {}),
    restaurants: _.get(state, "planDinner.restaurants"),
    loadingMenus: _.get(state, "loadingState.loadingMenus"),
  }
}

RestaurantList.defaultProps = {
  isDateWait: false,
}

export default withRouter(
  connect(mapStateToProps, {
    suggestRestaurant,
    getRestaurantMenu,
    setLoadingMenus,
  })(RestaurantList)
)
